var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reload)?_c('div',{staticClass:"loading-wrapper"},[_vm._m(0),_c('div',{staticClass:"loading_title"},[_vm._v("加载中…")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('span',[_vm._v("北方人才")]),_c('span',[_vm._v("数")]),_c('span',[_vm._v("据")]),_c('span',[_vm._v("驾")]),_c('span',[_vm._v("驶")]),_c('span',[_vm._v("舱")])])
}]

export { render, staticRenderFns }